/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateNoteRequest,
  ListNotesResponse,
  Note,
  Problem,
  UpdateNoteRequest,
} from '../models/index';
import {
    CreateNoteRequestFromJSON,
    CreateNoteRequestToJSON,
    ListNotesResponseFromJSON,
    ListNotesResponseToJSON,
    NoteFromJSON,
    NoteToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateNoteRequestFromJSON,
    UpdateNoteRequestToJSON,
} from '../models/index';

export interface CreateNoteOperationRequest {
    createNoteRequest: CreateNoteRequest;
}

export interface DeleteNoteRequest {
    noteId: number;
}

export interface GetNoteRequest {
    noteId: number;
}

export interface ListNotesRequest {
    claimId?: number;
    companyId?: number;
    limit?: number;
    offset?: number;
}

export interface UpdateNoteOperationRequest {
    noteId: number;
    updateNoteRequest: UpdateNoteRequest;
}

/**
 * NotesApi - interface
 * 
 * @export
 * @interface NotesApiInterface
 */
export interface NotesApiInterface {
    /**
     * 
     * @summary Create a note
     * @param {CreateNoteRequest} createNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApiInterface
     */
    createNoteRaw(requestParameters: CreateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Note>>;

    /**
     * Create a note
     */
    createNote(requestParameters: CreateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Note>;

    /**
     * 
     * @summary Delete a note
     * @param {number} noteId Note ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApiInterface
     */
    deleteNoteRaw(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a note
     */
    deleteNote(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get a note by ID
     * @param {number} noteId Note ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApiInterface
     */
    getNoteRaw(requestParameters: GetNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Note>>;

    /**
     * Get a note by ID
     */
    getNote(requestParameters: GetNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Note>;

    /**
     * 
     * @summary List notes
     * @param {number} [claimId] Filter by claim ID
     * @param {number} [companyId] Filter by company ID
     * @param {number} [limit] Maximum number of notes to return
     * @param {number} [offset] Number of notes to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApiInterface
     */
    listNotesRaw(requestParameters: ListNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListNotesResponse>>;

    /**
     * List notes
     */
    listNotes(requestParameters: ListNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListNotesResponse>;

    /**
     * 
     * @summary Update a note
     * @param {number} noteId Note ID
     * @param {UpdateNoteRequest} updateNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApiInterface
     */
    updateNoteRaw(requestParameters: UpdateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Note>>;

    /**
     * Update a note
     */
    updateNote(requestParameters: UpdateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Note>;

}

/**
 * 
 */
export class NotesApi extends runtime.BaseAPI implements NotesApiInterface {

    /**
     * Create a note
     */
    async createNoteRaw(requestParameters: CreateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Note>> {
        if (requestParameters['createNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'createNoteRequest',
                'Required parameter "createNoteRequest" was null or undefined when calling createNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNoteRequestToJSON(requestParameters['createNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NoteFromJSON(jsonValue));
    }

    /**
     * Create a note
     */
    async createNote(requestParameters: CreateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Note> {
        const response = await this.createNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a note
     */
    async deleteNoteRaw(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling deleteNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notes/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a note
     */
    async deleteNote(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Get a note by ID
     */
    async getNoteRaw(requestParameters: GetNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Note>> {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling getNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notes/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NoteFromJSON(jsonValue));
    }

    /**
     * Get a note by ID
     */
    async getNote(requestParameters: GetNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Note> {
        const response = await this.getNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List notes
     */
    async listNotesRaw(requestParameters: ListNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListNotesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListNotesResponseFromJSON(jsonValue));
    }

    /**
     * List notes
     */
    async listNotes(requestParameters: ListNotesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListNotesResponse> {
        const response = await this.listNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a note
     */
    async updateNoteRaw(requestParameters: UpdateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Note>> {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling updateNote().'
            );
        }

        if (requestParameters['updateNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'updateNoteRequest',
                'Required parameter "updateNoteRequest" was null or undefined when calling updateNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notes/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNoteRequestToJSON(requestParameters['updateNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NoteFromJSON(jsonValue));
    }

    /**
     * Update a note
     */
    async updateNote(requestParameters: UpdateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Note> {
        const response = await this.updateNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
